import { ProductPaginatedResult } from '@shared/types/result';
import { ComposableCommerceEventsB2B } from '../../types/events/ComposableCommerceEventsB2B';
import { CommercetoolsSdk } from '../Integration';

export type CheckoutCartActions = {
    getCart: any;
    addToCart: any;
    updateItemQuantity: any;
    removeItem: any;
    removeAllItems: any;
    validateCart: any;
    submitOrder: any;
    createOrder: any;
    addCoupon: any;
    removeCoupon: any;
};

export const getCheckoutCartActions = (sdk: CommercetoolsSdk<ComposableCommerceEventsB2B>): CheckoutCartActions => {
    return {
        getCart: async (payload: any) => {

            const response = await sdk.call<ProductPaginatedResult>({
                actionName: 'checkout-cart/getCart',
                payload: {
                    ...payload,
                },
            });
            return response;
        },
        addToCart: async (payload: any) => {
            const response = await sdk.call<ProductPaginatedResult>({
                actionName: 'checkout-cart/addToCart',
                payload: {
                    ...payload,
                },
            });

            return response;
        },

        updateItemQuantity: async (payload: any) => {
            const response = await sdk.call<ProductPaginatedResult>({
                actionName: 'checkout-cart/updateItemQuantity',
                payload: {
                    ...payload,
                },
            });

            return response;
        },

        removeItem: async (payload: any) => {
            const response = await sdk.call<ProductPaginatedResult>({
                actionName: 'checkout-cart/removeItem',
                payload: {
                    ...payload,
                },
            });

            return response;
        },

        removeAllItems: async (payload: any) => {
            const response = await sdk.call<ProductPaginatedResult>({
                actionName: 'checkout-cart/removeAllItems',
                payload: {
                    ...payload,
                },
            });
            return response;
        },

        validateCart: async (payload: any) => {
            const response = await sdk.call<ProductPaginatedResult>({
                actionName: 'checkout-cart/validateCart',
                payload: {
                    ...payload,
                },
            });
            return response;
        },

        submitOrder: async (payload: any) => {
            const response = await sdk.call<ProductPaginatedResult>({
                actionName: 'checkout-cart/submitOrder',
                payload: {
                    ...payload,
                },
            });
            return response;
        },
        createOrder: async (payload: any) => {
            const response = await sdk.call<ProductPaginatedResult>({
                actionName: 'checkout-cart/createOrder',
                payload: {
                    ...payload,
                },
            });
            return response;
        },

        addCoupon: async (payload: any) => {
            const response = await sdk.call<ProductPaginatedResult>({
                actionName: 'checkout-cart/addCoupon',
                payload: {
                    ...payload,
                },
            });
            return response;
        },

        removeCoupon: async (payload: any) => {
            const response = await sdk.call<ProductPaginatedResult>({
                actionName: 'checkout-cart/removeCoupon',
                payload: {
                    ...payload,
                },
            });
            return response;
        },
    };
};
